<script setup lang="ts">
import type { NuxtError } from '#app'
import { isTRPCError } from '@autobid/strapi-integration/utils/getError'
import { SHOULD_USE_GLOBAL_BOUND_KEY } from '@autobid/ui/constants/SHOULD_USE_GLOBAL_BOUND_KEY'

const error = ref<NuxtError>()

const shouldUse: Ref<boolean> = inject(SHOULD_USE_GLOBAL_BOUND_KEY, ref(false))

function clearError() {
  error.value = undefined
}

onErrorCaptured((err) => {
  if (!shouldUse.value) {
    return
  }

  if (isTRPCError(err)) {
    const errorData = err.data

    error.value = createError({
      cause: err.cause,
      data: errorData,
      name: err.name,
      stack: err.stack,
      status: errorData.httpStatus,
      statusCode: errorData.httpStatus,
      statusMessage: errorData.code,
    })
    if (import.meta.server) {
      throw error.value
    }
  }
  else {
    error.value = createError({
      statusCode: isNuxtError(err) ? err.statusCode : 500,
      name: err.name,
      statusMessage: err.message,
      cause: err,
    })
  }

  if (process.dev) {
    console.error(error.value)
  }
})

const route = useRoute()
watch(
  () => route.fullPath,
  () => {
    error.value = undefined
  },
)
</script>

<template>
  <slot v-if="!error" />
  <slot v-else name="error" :error="error" :clear-error="clearError" />
</template>
